import { gql } from '@apollo/client';

const CREATE_POST = gql`
  mutation CreatePost(
    $body: String
    $categoryId: ID
    $tagIds: [ID!]
    $location: String
  ) {
    createPost(
      body: $body
      categoryId: $categoryId
      tagIds: $tagIds
      location: $location
    ) {
      success
      errors
      post {
        uuid
        body
        location
        createdAt
        isActive
        category { id name }
        tags { id name category }
        author { id displayName avatar }
      }
    }
  }
`;

const UPDATE_POST = gql`
  mutation UpdatePost(
    $uuid: ID!
    $body: String
    $categoryId: ID
    $tagIds: [ID!]
    $location: String
    $isActive: Boolean
  ) {
    updatePost(
      uuid: $uuid
      body: $body
      categoryId: $categoryId
      tagIds: $tagIds
      location: $location
      isActive: $isActive
    ) {
      success
      errors
      post {
        uuid
        body
        location
        isActive
        archivedAt
        category { id name }
        tags { id name category }
      }
    }
  }
`;

const UPDATE_COLLABORATION_PROFILE = gql`
  mutation UpdateCollaborationProfile(
    $openToCollaboration: Boolean
    $addTagIds: [ID!]
    $removeTagIds: [ID!]
  ) {
    updateCollaborationProfile(
      openToCollaboration: $openToCollaboration
      addTagIds: $addTagIds
      removeTagIds: $removeTagIds
    ) {
      success
      errors
      sbuUser {
        id
        openToCollaboration
        tags { id name category }
      }
    }
  }
`;

const CONNECT_FROM_COMMUNITY = gql`
  mutation ConnectFromCommunity($sbuUserId: ID!) {
    connectFromCommunity(sbuUserId: $sbuUserId) {
      success
      errors
      connection {
        uuid
        isApproved
        connection {
          username
          firstName
          lastName
        }
      }
    }
  }
`;

export { CREATE_POST, UPDATE_POST, UPDATE_COLLABORATION_PROFILE, CONNECT_FROM_COMMUNITY };
